import React from "react";
import styles from "./SocialButton.module.css";
const SocialButton = ({ icon, title, onClick, isLastUsed = false,provider,eventName }) => {
  const handleClick = (e) => {
    onClick && onClick(provider,eventName);
  };

  return (
    <button type="button" className={styles.socialBtn} onClick={handleClick}>
      {isLastUsed ? <span className={styles.lastUsed}>Last used</span> : null}
      <span className={styles.socialIcon}>{icon}</span>
      <span className={styles.socialText}>{title}</span>
    </button>
  );
};

export { SocialButton };
